import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Stack, Card, Container, Row, Col, Nav, Tab } from 'react-bootstrap'
// import { pageNames } from 'src/routes/pathParams'
// import { Link } from 'react-router-dom'
import {
  i18nTranslate,
  getLiveEventStatus,
  trackGTMEvents,
  currencyFormat,
  getLocalStorage,
  handleGPS3DSRedirectStatus,
  isCSRActOnBehalfSession,
  is3DSEnabledForGPS,
  deletePaymentById,
  triggerGPS3DSInitiateCall,
  isFeatureEnabled,
  convertToBoolean,
  isGPSEnabled,
} from 'src/utils'
import { BsFillExclamationCircleFill } from 'react-icons/bs'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import {
  loyaltyContainer,
  promotionContainer,
  subscriptionContainer,
  checkoutContainer,
  customerContainer,
} from 'src/models'
import { LoyaltyBlock } from './WalletBlock'
import { ServiceErrorUI, MetaDecorator, toastState } from 'src/views/components'
import LoyaltyProgressBar from 'src/views/components/LoyaltyProgressBar'
import LoyaltyForm from 'src/views/pages/MyAccount/MyAccountProfile/LoyaltyForm/LoyaltyForm'
import { PaymentBlock } from './Payments/PaymentBlock'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import {
  isLoyEnableInProf,
  isAllowedRewardTypeForOptIn,
} from 'src/views/pages/MyAccount/MyAccountProfile/LoyaltyForm/fixture'
import { loyaltyRewardsFormData } from './fixture'
import { storeContainer, cartContainer } from 'src/models'
import { Icons, MyaccountWallet } from 'src/views/components'
import { APPConfig, IS_BROWSER } from 'config/appConfig'
import { brandAffiliate, retailCustomer } from 'src/static/fixtures/links'
import './styles.scss'

@observer
class MyAccountWallet extends React.Component {
  @observable loyaltyProgress = {}
  @observable enableGlobalLoyaltyDashboard = convertToBoolean(
    storeContainer.getLoyaltyCSMConfig()?.enableLoyaltyVoucher
  )
  @observable enableLoyaltyPoints = convertToBoolean(
    storeContainer.getLoyaltyPointsConfig()
  )
  @observable rewardTransactions = []
  @observable globalPaymentResponse = {}
  @observable isGPS3DSEnabledInWallet = false
  @observable hideNewCardInWalletForGPS = false
  brandAffiliateLinks = {}
  retailCustomerLinks = {}

  WALLET_TABS = {
    NUSKIN_REWARDS: 'nuskinRewards',
    STORE_CREDITS: 'storeCredits',
    PROMOTIONS: 'promotions',
  }

  updateLoyaltyDashboardFlags = () => {
    this.enableGlobalLoyaltyDashboard = convertToBoolean(
      storeContainer.getLoyaltyCSMConfig()?.enableLoyaltyVoucher
    )
    this.enableLoyaltyPoints = convertToBoolean(
      storeContainer.getLoyaltyPointsConfig()
    )
  }

  openDocument = documentLink => {
    if (IS_BROWSER) {
      window.open(documentLink)
    }
  }

  composeLocaleBasedLegalLinks = () => {
    const defaultLocale =
      APPConfig?.getActiveAppConfig()?.defaultLocale ||
      getLocalStorage('defaultLocale')

    const locale = defaultLocale?.replaceAll('-', '_')?.toLowerCase()
    const activeLocale = [locale]

    const filteredBrandLocale = Object.keys(brandAffiliate)
      .filter(key => activeLocale.includes(key))
      .reduce((obj, key) => {
        obj[key] = brandAffiliate[key]
        return obj
      }, {})
    this.brandAffiliateLinks = filteredBrandLocale[locale]

    const filteredRetailLocale = Object.keys(retailCustomer)
      .filter(key => activeLocale.includes(key))
      .reduce((obj, key) => {
        obj[key] = retailCustomer[key]
        return obj
      }, {})

    this.retailCustomerLinks = filteredRetailLocale[locale]

    return this.retailCustomerLink !== '' ? true : false
  }

  renderTransaction = () => {
    return <LoyaltyBlock {...this.props} />
  }

  getRewardHistoryColumns = () => [
    { label: i18nTranslate('loyalty.date', 'Date'), key: 'date' },
    { label: i18nTranslate('loyalty.status', 'Status'), key: 'status' },
    { label: i18nTranslate('loyalty.voucher', 'Voucher'), key: 'voucher' },
    { label: i18nTranslate('loyalty.expired', 'Expired'), key: 'expired' },
  ]

  async componentDidMount() {
    this.updateLoyaltyDashboardFlags()
    await this.handleWallet3DSRedirectStatus()

    const globalPaymentOptionsResponse =
      await checkoutContainer.getGlobalPaymentOptions(false, true)
    this.globalPaymentResponse =
      globalPaymentOptionsResponse?.response ||
      checkoutContainer?.globalPaymentResponse ||
      {}
    const validProcessorObj = checkoutContainer.getValidGPSCreditCardProcessor()
    this.isGPS3DSEnabledInWallet = is3DSEnabledForGPS(validProcessorObj)
    this.hideNewCardInWalletForGPS =
      isGPSEnabled() && !checkoutContainer.hasGPSCreditCardOption()

    await this.getLoyaltyPoints()
    await this.getStoreCredits()
    await this.getLoyaltyProgress()
    this.updateLoyaltyDashboardFlags()
    const enableLoyaltyRewardsTab = isFeatureEnabled('RewardsTabbedView')
    if (enableLoyaltyRewardsTab) {
      await subscriptionContainer.getCSMSubscriptionData()
      this.transformCSMSubscriptionData()
      const transactionsResponse =
        await loyaltyContainer.getLoyaltyTransactionsList()
      this.rewardTransactions = transactionsResponse?.transactions || []
    }
  }

  handleWallet3DSRedirectStatus = async () => {
    const result = await handleGPS3DSRedirectStatus({
      paymentIdSessionKey: 'wallet3ds_paymentId',
      orderIdSessionKey: 'wallet3ds_orderId',
      deletePaymentById: this.deleteWalletPayment,
      fetchResponse: params => checkoutContainer.fetchResponse(params),
      isSuccessResponse: response =>
        checkoutContainer.isSuccessResponse(response),
      storeId: APPConfig.getAppConfig()?.storeId,
      zeroDollarAuthEndPointName: 'addAccountPaymentForPaymetric3ds',
    })

    if (result?.hasError) {
      toastState.setToastMessage(result.message, false)
      // The invalid card was already deleted server-side (handleGPS3DSRedirectStatus),
      // so just refetch the wallet list instead of reloading the page -
      // keeps the toast visible and drops the invalid card from the UI.
      await customerContainer.getPayment()
    }
  }

  transformCSMSubscriptionData = () => {
    const csmData = subscriptionContainer.subscriptionCSMData
    const input = csmData?.csmMonthlySubsOrderTotal ?? []
    const grouped = new Map()

    for (const entry of input) {
      const key = `${entry.year}-${entry.month}`
      if (!grouped.has(key)) {
        grouped.set(key, {
          year: entry.year,
          month: entry.month,
          subtotal: 0,
          items: [],
        })
      }
      const group = grouped.get(key)

      if (entry.rewardType === 'SUBTOTAL') {
        group.subtotal += entry.otrValue ?? 0
      } else {
        const rewardType =
          typeof entry.rewardType === 'string' &&
          entry.rewardType.startsWith('CSM')
            ? `NSR${entry.rewardType.slice(3)}`
            : entry.rewardType
        group.items.push({ ...entry, rewardType })
      }
    }

    const output = []
    for (const { year, month, subtotal, items } of grouped.values()) {
      if (subtotal > 0) {
        output.push({
          year,
          month,
          rewardType: 'SUBTOTAL',
          totalAmount: subtotal,
          otrValue: subtotal,
        })
      }
      output.push(...items)
    }

    subscriptionContainer.subscriptionCSMData = {
      ...csmData,
      csmMonthlySubsOrderTotal: output,
    }
  }

  getLoyaltyPoints = async () => {
    await loyaltyContainer.getLoyaltyPoints(true)
  }

  getStoreCredits = async () => {
    await loyaltyContainer.getStoreCredits()
  }

  getLoyaltyProgress = async () => {
    this.loyaltyProgress = await loyaltyContainer.getLoyaltyProgress(
      this.enableLoyaltyPoints
    )
  }

  getLastDayCurrentMonth = () => {
    let date = new Date()
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    return lastDay
  }

  getOpenToRedeem = () => {
    return this.loyaltyProgress?.userMath?.LOYALTY?.total?.openToRedeem || 0
  }

  deleteWalletPayment = async paymentId => {
    await deletePaymentById({
      paymentId,
      fetchResponse: params => customerContainer.fetchResponse(params),
    })
  }

  triggerWallet3DSInitiateCall = async paymentId => {
    return triggerGPS3DSInitiateCall({
      paymentId,
      isGPS3DSEnabled: this.isGPS3DSEnabledInWallet,
      isCSRActOnBehalf: isCSRActOnBehalfSession(),
      deletePaymentById: this.deleteWalletPayment,
      fetchResponse: params => checkoutContainer.fetchResponse(params),
      isSuccessResponse: response =>
        checkoutContainer.isSuccessResponse(response),
      storeId: APPConfig.getAppConfig()?.storeId,
      paymentIdSessionKey: 'wallet3ds_paymentId',
      orderIdSessionKey: 'wallet3ds_orderId',
      initiateEndPointName: 'addAccountPaymentForPaymetric3ds',
    })
  }

  renderLoyaltyBlock = () => {
    let expirationDate = ''
    expirationDate =
      loyaltyContainer.loyaltyPointsResponse?.nextExpirationDate || ''

    const loyaltyPnts =
      loyaltyContainer.loyaltyPointsResponse?.userMath?.LOYALTY?.total
        ?.openToRedeem || 0

    if (expirationDate === '') {
      expirationDate = this.getLastDayCurrentMonth()
    }
    const dateExpirationFormat = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      //Fix for EQPLAT-12720 UTCdate
      timeZone: 'UTC',
    }).format(expirationDate)

    const valueStatic = 50

    const tier = loyaltyContainer.loyaltyPointsResponse.tier || ''
    let tierValue = storeContainer.getTierConfigMapValue(tier, true)
    tierValue = tierValue || ''
    const rate =
      tierValue.indexOf('%') > -1
        ? tierValue
        : tierValue === ''
          ? '0%'
          : tierValue + '%'
    const expirationBalance =
      loyaltyContainer.loyaltyPointsResponse?.nextExpirationPoints || 0

    const loyaltyDataArray = [
      {
        key: i18nTranslate(
          'loyalty.totalEarnedPoints',
          'Total Points Available'
        ),
        value: `${'$'}${loyaltyPnts?.toFixed(2) || loyaltyPnts}`,
        datatestid: 'qa-user-loyalty-total-earned-points',
      },
    ]

    // !storeContainer.isCARegion() &&
    // loyaltyDataArray.push({
    //   key: i18nTranslate('loyalty.expiringMonth', 'Points Expiring Soon'),
    //   value: `${'$'}${expirationBalance?.toFixed(2) || expirationBalance}`,
    // })

    isLoyEnableInProf() &&
      loyaltyDataArray.push({
        key: i18nTranslate('loyalty.currentRate', 'Current Tier'),
        value: `${
          rate?.toLowerCase()?.indexOf('redeem only') > -1
            ? rate?.split('-')?.[0]
            : rate
        }`,
        datatestid: 'qa-user-loyalty-current-earn-rate',
      })

    return (
      <Row noGutters>
        {loyaltyDataArray.map(loyaltyData => {
          const isCurrentMonthPV =
            loyaltyData.key.toLowerCase() === 'current month pv'
          const isPointsExpiringSoon =
            loyaltyData.key.toLowerCase() === 'points expiring soon'
          const isCurrentTier = loyaltyData.key.toLowerCase() === 'current tier'
          const tierVal = isCurrentTier ? loyaltyData.value.split('-') : ''
          const tierPercentage = tierVal ? tierVal.pop() : ''
          const tierValues = tierVal ? tierVal.join(' ') : ''
          const point = isCurrentTier ? 'tierPoint d-table' : 'point'

          return (
            <Col
              key={loyaltyData.key}
              xs={12}
              md={3}
              className="loyalty-current-points d-flex mr-10 mt-1 py-1 pr-2">
              <div className="points-container d-flex flex-column justify-content-center align-items-center">
                <Col className="loyalty-wrap-text">
                  <span
                    className="loyalty-text mb-auto text-uppercase"
                    data-testid="qa-loyalty-current-points">
                    {isPointsExpiringSoon && loyaltyPnts > 0
                      ? `${loyaltyData.key} (${dateExpirationFormat})`
                      : `${loyaltyData.key}`}
                  </span>
                </Col>
                <span className={point} data-testid={loyaltyData.datatestid}>
                  {isCurrentMonthPV ? (
                    <span>
                      {loyaltyData.value >= valueStatic ? (
                        <span className="success-tick">
                          <Icons
                            name="CRUD"
                            icontype="tick"
                            width="31px"
                            height="37px"
                            color="#3E7957"
                          />
                        </span>
                      ) : (
                        <span className="failure-tick">
                          <Icons
                            name="CRUD"
                            width="40px"
                            height="37px"
                            icontype="cross"
                            color="#BE1217"
                          />
                        </span>
                      )}
                      {loyaltyData.value}/
                      <span className="valueLittle">{valueStatic}</span>
                    </span>
                  ) : (
                    <>
                      {isCurrentTier ? (
                        <div className="d-table-cell align-middle">
                          <span>{tierValues}</span>
                          <span>{tierPercentage}</span>
                          {/* commented cx121-2283, redeem only to display */}
                          {/* {!isBrandAffiliateTypeProfile() && (
                            <>
                              <br></br>
                              <span>{tierPercentage}</span>
                            </>
                          )} */}
                        </div>
                      ) : (
                        `${loyaltyData.value}`
                      )}
                    </>
                  )}
                </span>
              </div>
            </Col>
          )
        })}
      </Row>
    )
  }
  renderStoreCreditsBlock = () => {
    const enableLiveEvent = getLiveEventStatus()

    if (enableLiveEvent === 'true') {
      trackGTMEvents({
        event: 'view_store_credit',
        available_store_credits: loyaltyContainer.storeCreditPoints || 0,
      })
    }

    const storeCreditsDataArray = [
      {
        key: i18nTranslate(
          'loyalty.availableStoreCredits',
          'Available Store Credits'
        ),
        value: loyaltyContainer.storeCreditPoints || 0,
      },
    ]
    return (
      <Card
        className="store-credit bg-light"
        data-testid="qa-wallet-store-credit-card">
        {storeCreditsDataArray.map((storeCreditsData, idx) => {
          const availableStoreCredits = currencyFormat({
            price: storeCreditsData.value,
          })
          return (
            <Card.Body key={storeCreditsData.key} className="store-credit">
              <Card.Title tabIndex={0}>
                <h2
                  className="store-credit-title"
                  data-testid="qa-wallet-store-credit-title">
                  {i18nTranslate(
                    'loyalty.loyaltyPointsStoreCredits',
                    'Store Credits'
                  )}
                </h2>
              </Card.Title>

              <Card.Text
                tabIndex={0}
                data-testid="qa-wallet-store-credit-value"
                aria-description={`${storeCreditsData.key} ${availableStoreCredits}`}>
                {availableStoreCredits}
              </Card.Text>
            </Card.Body>
          )
        })}
      </Card>
    )
  }
  renderProductPointsBlock = () => {
    return (
      <Card
        className="store-credit bg-light"
        data-testid="qa-wallet-product-point-card">
        <Card.Body className="store-credit">
          <Card.Title tabIndex={0}>
            <h2
              className="store-credit-title"
              data-testid="qa-wallet-product-point-title">
              {i18nTranslate(
                'loyalty.loyaltyPointsProductPoints',
                'Available Product Points: '
              )}
              {this.getOpenToRedeem()}
            </h2>
          </Card.Title>
        </Card.Body>
      </Card>
    )
  }
  renderServiceFailure = () => {
    return (
      <div className="err-subscription mb-2">
        <ServiceErrorUI />
      </div>
    )
  }

  renderProgressBar = () => {
    const tier = loyaltyContainer.loyaltyPointsResponse?.tier || ''
    const tierValue = storeContainer.getTierConfigMapValue(tier)
    return <LoyaltyProgressBar {...tierValue} progressTier={tier} />
  }

  formatRewardDate = timestamp => {
    if (!timestamp) return ''
    const locale = (APPConfig.getAppConfig()?.defaultLocale || 'en_US').replace(
      '_',
      '-'
    )
    return new Intl.DateTimeFormat(locale, {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(timestamp))
  }

  getRewardHistoryData = () => {
    const transactions = this.rewardTransactions || []
    const result = []
    transactions.forEach((transactionData, transactionIndex) => {
      const voucherList = Array.isArray(transactionData?.voucher)
        ? transactionData.voucher
        : []
      if (voucherList.length > 0) {
        voucherList.forEach((voucherDetail, voucherDetailId) => {
          result.push({
            key: `${transactionData?.transactionId ?? transactionIndex}-${voucherDetail?.voucherId ?? voucherDetailId}`,
            date: this.formatRewardDate(transactionData?.effectiveDate),
            status: transactionData?.type || '',
            voucher: (() => {
              const raw = voucherDetail?.voucherType || ''
              return raw.startsWith('VOUCHER_') ? raw.split('VOUCHER_')[1] : raw
            })(),
            points: transactionData?.rewardValue || '',
            expired: this.formatRewardDate(
              voucherDetail?.expiryTime || transactionData?.expiryTime
            ),
          })
        })
      } else {
        result.push({
          key: `${transactionData?.transactionId ?? transactionIndex}-0`,
          date: this.formatRewardDate(transactionData?.effectiveDate),
          status: transactionData?.type || '',
          voucher: transactionData?.voucherName || '',
          points: transactionData?.rewardValue || '',
          expired: this.formatRewardDate(transactionData?.expiryTime),
        })
      }
    })
    return result
  }

  renderRewardHistory = () => {
    if (loyaltyContainer.isRewardHistoryLoading) {
      return (
        <Card className="bg-light reward-history-card">
          <Card.Body>
            <Card.Title tabIndex={0}>
              <h2
                className="reward-history-title"
                data-testid="qa-reward-history-title">
                {i18nTranslate('myaccount.rewardHistory', 'Reward History')}
              </h2>
            </Card.Title>
            <p>{i18nTranslate('common.loading', 'Loading...')}</p>
          </Card.Body>
        </Card>
      )
    }

    const rewardData = this.getRewardHistoryData()
    const enableLoyaltyPoints = storeContainer.getLoyaltyPointsConfig() || false

    return (
      <>
        {enableLoyaltyPoints && this.renderProductPointsBlock()}
        <Card className="bg-light reward-history-card">
          <Card.Body>
            <Card.Title tabIndex={0}>
              <h2
                className="reward-history-title"
                data-testid="qa-reward-history-title">
                {i18nTranslate('myaccount.rewardHistory', 'Reward History')}
              </h2>
            </Card.Title>
            <Row noGutters className="reward-history-header py-3" role="row">
              {this.getRewardHistoryColumns().map(col => (
                <Col
                  key={col.key}
                  className="loyalty-wrap-text"
                  role="columnheader">
                  <span
                    className="loyalty-points-history-table-text text-uppercase paragraph-m-bold"
                    data-testid={`qa-reward-history-column-${col.key}`}>
                    {col.label}
                  </span>
                </Col>
              ))}
            </Row>
            {rewardData.map(item => (
              <Row
                noGutters
                className="reward-history-row border-bottom py-3"
                key={item.key}
                role="row"
                data-testid="qa-reward-history-row">
                <Col role="cell">
                  <span
                    className="transaction-value"
                    data-testid="qa-reward-history-date">
                    {item.date}
                  </span>
                </Col>
                <Col role="cell">
                  <span
                    className="transaction-value"
                    data-testid="qa-reward-history-status">
                    {item.status}
                  </span>
                </Col>
                <Col role="cell">
                  <span
                    className="transaction-value"
                    data-testid="qa-reward-history-voucher">
                    {enableLoyaltyPoints ? item.points : item.voucher}
                  </span>
                </Col>
                <Col role="cell">
                  <span
                    className="transaction-value"
                    data-testid="qa-reward-history-expired">
                    {item.expired ? item.expired : '-'}
                  </span>
                </Col>
              </Row>
            ))}
          </Card.Body>
        </Card>
      </>
    )
  }

  renderTabs = ({
    apiStatus,
    isServiceFailure,
    enablePaymentMethodsInWallet,
    hidePromotions,
    summaryValues,
  }) => {
    const enableLoyaltyRewardsTab = isFeatureEnabled('RewardsTabbedView')
    const defaultActiveKey = enableLoyaltyRewardsTab
      ? this.WALLET_TABS.NUSKIN_REWARDS
      : this.WALLET_TABS.STORE_CREDITS

    const enableStoreCreditInWallet = isFeatureEnabled(
      'enableStoreCreditInWallet'
    )

    const enableLoyaltyPoints = storeContainer.getLoyaltyPointsConfig() || false
    return (
      <Tab.Container id="wallet-tabs" defaultActiveKey={defaultActiveKey}>
        <Nav
          as="nav"
          variant="tabs"
          role="tablist"
          className="wallet-section-tabs mb-3">
          {enableLoyaltyRewardsTab && (
            <Nav.Link
              eventKey={this.WALLET_TABS.NUSKIN_REWARDS}
              className="nav-item"
              data-testid="qa-wallet-tab-nuskin-rewards">
              {i18nTranslate('myaccount.nuSkinRewards', 'NuSkin Rewards')}
            </Nav.Link>
          )}
          {(enableStoreCreditInWallet || enablePaymentMethodsInWallet) && (
            <Nav.Link
              eventKey={this.WALLET_TABS.STORE_CREDITS}
              className="nav-item"
              data-testid="qa-wallet-tab-store-credits">
              {enableStoreCreditInWallet
                ? i18nTranslate('myaccount.storeCredits', 'Store Credits')
                : i18nTranslate('myaccount.payments', 'Payment Methods')}
            </Nav.Link>
          )}
          {!hidePromotions && (
            <Nav.Link
              eventKey={this.WALLET_TABS.PROMOTIONS}
              className="nav-item"
              data-testid="qa-wallet-tab-promotions">
              {i18nTranslate('pdp.pdpPromotionsLabelTxt', 'Promotions', {
                nameSpace: 'ssr-resource',
              })}
            </Nav.Link>
          )}
        </Nav>
        <Tab.Content>
          {enableLoyaltyRewardsTab && (
            <Tab.Pane eventKey={this.WALLET_TABS.NUSKIN_REWARDS}>
              {apiStatus === 'failure' && isServiceFailure ? (
                this.renderServiceFailure()
              ) : (
                <>
                  {!enableLoyaltyPoints && (
                    <LoyaltyMFEContainer
                      componentName="ProgressBar"
                      isFrom="WALLET"></LoyaltyMFEContainer>
                  )}
                  {this.renderRewardHistory()}
                </>
              )}
            </Tab.Pane>
          )}
          {(enableStoreCreditInWallet || enablePaymentMethodsInWallet) && (
            <Tab.Pane eventKey={this.WALLET_TABS.STORE_CREDITS}>
              {enableStoreCreditInWallet && this.renderStoreCreditsBlock()}
              {enablePaymentMethodsInWallet && (
                <Row className={`py-2`}>
                  <Col>
                    <PaymentBlock
                      {...this.props}
                      isGPS3DSEnabledInWallet={this.isGPS3DSEnabledInWallet}
                      hideAddNewCard={this.hideNewCardInWalletForGPS}
                      onTriggerWallet3DS={this.triggerWallet3DSInitiateCall}
                    />
                  </Col>
                </Row>
              )}
            </Tab.Pane>
          )}
          {!hidePromotions && (
            <Tab.Pane eventKey={this.WALLET_TABS.PROMOTIONS}>
              <Card
                className={'bg-light'}
                data-testid="qa-wallet-promotions-card">
                <Card.Body>
                  <Card.Title tabIndex={0}>
                    <h2
                      className="promotions-title"
                      data-testid="qa-wallet-promotions-title">
                      {i18nTranslate(
                        'pdp.pdpPromotionsLabelTxt',
                        'Promotions',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )}
                    </h2>
                  </Card.Title>

                  <MyaccountWallet
                    math={summaryValues}
                    onContinue={this.props?.onContinue}
                    isStoreCredit={this.props?.isStoreCredit}
                    updateFlowPaths={this.props?.updateFlowPaths}
                  />
                </Card.Body>
              </Card>
            </Tab.Pane>
          )}
        </Tab.Content>
      </Tab.Container>
    )
  }

  render() {
    const apiStatus = loyaltyContainer.loyaltyPointsResponse?.apiStatus || ''
    const isServiceFailure =
      loyaltyContainer.loyaltyPointsResponse?.isServiceFailure || false
    const myAccountLoyaltyTitle = i18nTranslate(
      'myAccountLoyaltyPage.title',
      'Loyalty | Nu Skin'
    )
    const accountType = getLocalStorage('accountType')
    const hideLoyaltyAlways =
      APPConfig?.getAppConfig()?.hideLoyaltyAlways === 'true'
    const storeIdBasedOnCountry =
      storeContainer?.storeIDValue?.toLowerCase() || ''
    const isCanada =
      storeIdBasedOnCountry === 'canada' || storeIdBasedOnCountry === 'ca'
    const hideLoyaltyForUS =
      APPConfig?.getAppConfig()?.hideLoyaltyForUS === 'true'
    const isUS = storeIdBasedOnCountry === 'us'
    const isToHideLoyaltyForUS = hideLoyaltyForUS && isUS
    const enablePaymentMethodsInWallet =
      APPConfig?.getAppConfig()?.enablePaymentMethodsInWallet === 'true'
    const enableStoreCreditInWallet =
      APPConfig?.getAppConfig()?.enableStoreCreditInWallet === 'true'

    const value = cartContainer?.cartResponse?.value || ''

    const loyaltyAppliedResult = cartContainer?.cartResponse.payments?.find(
      item => item?.type?.toLocaleLowerCase() === 'loyalty'
    )
    const redeemedLoyaltyPoints = loyaltyAppliedResult?.amount || 0
    const balance = cartContainer?.cartResponse?.loyalty?.totalPoints || 0
    const storeCredit = cartContainer.redeemedStoreCreditPoints()
    const otherChargesIncludingTax = value?.otherChargesIncludingTax || 0
    const totalInclusiveTax =
      cartContainer?.cartResponse?.value?.totalInclusiveTax || 0

    const summaryValues = {
      priceAfterMarkdown: value.priceAfterMarkdown,
      cartDeliveryCharge: value.cartDeliveryCharge,
      totalDiscount: value.totalDiscount,
      overAllTax: value.overAllTax,
      grandTotal: value.grandTotal - redeemedLoyaltyPoints - storeCredit,
      overAllDiscount: value.overAllDiscount,
      redeemedLoyaltyPoints: redeemedLoyaltyPoints,
      redeemableLoyaltyPoints: value.totalLoyaltyPointsToPay,
      openLoyaltyPoints: balance,
      count: value.count,
      cartDeliveryChargeDiscount: value.cartDeliveryChargeDiscount,
      storeCredit: storeCredit,
      cartDeliveryChargeAfterDiscount: value.cartDeliveryChargeAfterDiscount,
      loyaltyDiscount: value?.loyaltyDiscount,
      otherChargesIncludingTax: otherChargesIncludingTax,
      otherCharges: value?.otherCharges,
      totalInclusiveTax: totalInclusiveTax,
    }

    const hidePromotions = promotionContainer.checkSitePromotion()

    return (
      <>
        <MetaDecorator
          title={myAccountLoyaltyTitle}
          imageUrl=""
          imageAlt=""
          description="My Wallet"
          location={this.props}
        />
        <Container
          className={`MyWallet bg-white`}
          data-testid="qa-wallet-container">
          <h1 className="wallet-section-title" data-testid="qa-wallet-title">
            {i18nTranslate('myaccount.wallet', 'Wallet')}
          </h1>
          {this.enableGlobalLoyaltyDashboard || this.enableLoyaltyPoints ? (
            this.renderTabs({
              apiStatus,
              isServiceFailure,
              enablePaymentMethodsInWallet,
              hidePromotions,
              summaryValues,
            })
          ) : (
            <>
              <Row className={`py-2`}>
                <Col>
                  {apiStatus === 'failure' && isServiceFailure
                    ? this.renderServiceFailure()
                    : enableStoreCreditInWallet && (
                        <>{this.renderStoreCreditsBlock()}</>
                      )}
                </Col>
              </Row>
              {!hidePromotions && (
                <Row className={`py-2`}>
                  <Col>
                    <Card
                      className={'bg-light'}
                      data-testid="qa-wallet-promotions-card">
                      <Card.Body>
                        <Card.Title tabIndex={0}>
                          <h2
                            className="promotions-title"
                            data-testid="qa-wallet-promotions-title">
                            {i18nTranslate(
                              'pdp.pdpPromotionsLabelTxt',
                              'Promotions',
                              {
                                nameSpace: 'ssr-resource',
                              }
                            )}
                          </h2>
                        </Card.Title>

                        <MyaccountWallet
                          math={summaryValues}
                          onContinue={this.props?.onContinue}
                          isStoreCredit={this.props?.isStoreCredit}
                          updateFlowPaths={this.props?.updateFlowPaths}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
              {enablePaymentMethodsInWallet && (
                <Row className={`py-2`}>
                  <Col>
                    <PaymentBlock
                      {...this.props}
                      isGPS3DSEnabledInWallet={this.isGPS3DSEnabledInWallet}
                      hideAddNewCard={this.hideNewCardInWalletForGPS}
                      onTriggerWallet3DS={this.triggerWallet3DSInitiateCall}
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        </Container>
      </>
    )
  }
}

export default MyAccountWallet
export { MyAccountWallet }
